import { Pagination, Table } from "antd";
import { useState } from "react";

function TransactionsTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const data = [
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 07, 2024 02:34 PM",
      action: "Deposit",
      details: "$ 1,500.00",
      ip: "192.168.0.1",
    },
    {
      date: "Sep 15, 2024 12:34 PM",
      action: "Withdrawal request",
      details: "$ 2,500.00",
      ip: "192.168.0.1",
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      sorter: (a, b) => a.action.localeCompare(b.action),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      sorter: (a, b) => a.details.localeCompare(b.details),
    },
    {
      title: "IP Address",
      dataIndex: "ip",
      key: "ip",
      sorter: (a, b) => a.ip.localeCompare(b.ip),
    },
  ];
  return (
    <div className="transactions-table-container">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey={(record) => record.id}
        scroll={{ x: 800, y: 500 }}
        onRow={(record) => ({
          onClick: () => {
            console.log(record);
          },
        })}
      />
      <div className="pagination">
        <Pagination
          current={currentPage}
          total={data.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}

export default TransactionsTable;
